<template>
    <v-dialog max-width="500px" v-model="dialog">
        <v-card min-width="400px">
            <v-card-title>
              <span class="headline">Changing Group</span>
            </v-card-title>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon class="ma-1" color="red" @click="onClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-actions>
            <v-card-actions>
                <v-select v-model="newGroup" :items="existingGroups" style="padding:0 25px"></v-select>
            </v-card-actions>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                        :loading="buttonLoading"
                        class="ma-2"
                        color="primary"
                        @click="onPressUse">CHANGE
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
            <v-divider class="mx-4"></v-divider>
            <v-card-title>
              <span class="subtitle-1">Rename Group</span>
            </v-card-title>
            <v-card-actions>
                <v-text-field
                    v-model="renameGroupName"
                    label="New Group Name"
                    outlined
                    dense
                    v-ascii-only
                    style="padding:0 25px">
                </v-text-field>
            </v-card-actions>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                        :loading="renameLoading"
                        class="ma-2"
                        color="primary"
                        @click="onPressRename">RENAME
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {ConfigStoreUtils} from "@/modules/mconfigs/database/ConfigStoreUtils";
import BranchStoreUtils from "@/modules/mconfigs/database/BranchStoreUtils";

export default {
    name: "c-edit-group-popup",
    data: () => ({
        buttonLoading: false,
        renameLoading: false,
        dialog: false,
        newGroup: "",
        renameGroupName: "",
        item: null
    }),
    computed: {
        existingGroups() {
            const branches = BranchStoreUtils.getValues() || [];
            return [...new Set(branches.flatMap(b => b.groups).map(g => g.name).filter(Boolean))];
        },
    },
    methods: {
        show(item) {
            this.item = item
            this.newGroup = this.item.group
            this.renameGroupName = this.item.group
            this.dialog = true
        },
        hide() {
            this.dialog = false
        },
        onClose() {
            this.dialog = false
        },
        onPressUse() {
            let item = this.item.clone()
            item.group = this.newGroup;
            item.deployed = false;
            this.buttonLoading = true
            ConfigStoreUtils.updateReleaseConfig(item, null).then(() => {
                this.$notify({title: 'Tag successfully changed!', text: "", type: "succes"});
                this.dialog = false
                this.buttonLoading = false
            }).catch((error) => {
                this.$notify({title: 'Tag change failed!', text: error, type: "error"});
                this.dialog = false
                this.buttonLoading = false
            })
        },
        onPressRename() {
            const trimmedName = this.renameGroupName.trim();
            const oldGroupName = this.item.group;

            if (!trimmedName) {
                this.$notify({title: 'Validation Error', text: 'Group name cannot be empty', type: "error"});
                return;
            }

            if (trimmedName.toLowerCase() === oldGroupName.toLowerCase()) {
                this.dialog = false;
                return;
            }

            const allBranches = BranchStoreUtils.getValues() || [];
            const duplicateGroup = allBranches.some(b =>
                b.groups.some(g => g.name?.toLowerCase() === trimmedName.toLowerCase())
            );

            if (duplicateGroup) {
                this.$notify({title: 'Validation Error', text: 'Group name already exists', type: "error"});
                return;
            }

            this.renameLoading = true;

            const branch = allBranches.find(b =>
                b.groups.some(g => g.name?.toLowerCase() === oldGroupName.toLowerCase())
            );

            let branchUpdatePromise = Promise.resolve();
            if (branch) {
                const branchCopy = branch.clone();
                const group = branchCopy.groups.find(g => g.name?.toLowerCase() === oldGroupName.toLowerCase());
                if (group) {
                    group.name = trimmedName;
                }
                branchUpdatePromise = BranchStoreUtils.pushValue(branchCopy);
            }

            const configsToUpdate = ConfigStoreUtils.getReleaseConfigs()
                .filter(c => c.group?.toLowerCase() === oldGroupName.toLowerCase());

            const configUpdates = configsToUpdate.map(config => {
                let copy = config.clone();
                copy.group = trimmedName;
                copy.deployed = false;
                return ConfigStoreUtils.updateReleaseConfig(copy, null);
            });

            Promise.all([branchUpdatePromise, ...configUpdates])
                .then(() => {
                    this.$notify({title: 'Group successfully renamed!', text: "", type: "success"});
                    this.dialog = false;
                })
                .catch((error) => {
                    this.$notify({title: 'Group rename failed!', text: error, type: "error"});
                })
                .finally(() => {
                    this.renameLoading = false;
                });
        }
    }
}
</script>
